import { RouteLocationRaw, Router, useRouter } from 'vue-router';
import { useSearchStore } from '#src/store/search';

export function useRouting(providedRouter?: Router) {
  const router = providedRouter || useRouter();

  async function toAccount(key: string | null | undefined) {
    if (!key) {
      return;
    }
    await router.push({ name: 'accountDashboard', params: { key } });
  }

  async function toDevice(key: string | null | undefined, serial: string | null | undefined, replace = false) {
    if (!serial) {
      return;
    }

    let location: RouteLocationRaw;
    if (key) {
      location = { name: 'accountDevice', params: { key, serial } };
    } else {
      location = { name: 'accountlessDevice', params: { serial } };
    }

    if (replace) {
      await router.replace(location);
    } else {
      await router.push(location);
    }
  }

  async function toSearch(newTerms: string) {
    const searchStore = useSearchStore();
    const { currentRoute } = router;

    const encodedTerms = newTerms.replace(/\+/g, '%2B');

    if (!encodedTerms) {
      await router.push({ name: 'home' });
    } else {
      const currentTerms = (<string>currentRoute.value.query.terms)?.replace(/\+/g, '%2B');
      if (currentRoute.value.name === 'home' && currentTerms === encodedTerms) {
        void searchStore.search(encodedTerms);
      } else {
        await router.push({ name: 'home', query: { terms: encodedTerms } });
      }
    }
  }

  return { toAccount, toDevice, toSearch };
}
